import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { House } from '@sunrun/component-library/icons';
import { SelectDropdown } from '@sunrun/component-library';
import { Color } from '@sunrun/mui-theme';
import mixpanel from '../../utilities/mixpanel';
import { ALERT_DOT_COLOR, DARK_BLUE_COLOR } from '../general/constants/_colors';
import { ADDRESS_SELECT_DROPDOWN_CLICKED, ADDRESS_SELECT_DROPDOWN_VISIBLE } from '../../constants/mixpanelEventNames';

const Container = styled.div`
  color: ${Color.WHITE};
`;

const Header = styled.div`
  text-align: center;

  svg {
    margin-right: 10px;
  }
`;

const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
  max-width: 100%;
`;

const StyledSelectDropdown = styled(SelectDropdown)`
  > div {
    box-shadow: none;
    padding: 0;
  }
`;

const ChargerAlertDot = styled.span`
  border-radius: 50%;
  position: absolute;
  background: ${ALERT_DOT_COLOR};
  width: 12px;
  height: 12px;
  right: -5px;
  top: 5px;
  z-index: 100;
`;

const MultipleOpptys = ({ changeServiceContract, selectedOption, options, isPVHasEV }) => {
  const { t } = useTranslation();
  const onSelectDropdownClick = () => {
    mixpanel.track(ADDRESS_SELECT_DROPDOWN_CLICKED);
  };

  useEffect(() => {
    mixpanel.track(ADDRESS_SELECT_DROPDOWN_VISIBLE);
  }, []);

  return (
    <Container>
      <Header>
        <House color={Color.WHITE} />
        {t('Home address')}
      </Header>
      <DropdownContainer>
        <StyledSelectDropdown
          options={options}
          onChange={e => changeServiceContract(e.value)}
          value={options?.filter(option => option.value === selectedOption)}
          menuHeight="400px"
          darkBackground={DARK_BLUE_COLOR}
          onClick={onSelectDropdownClick}
        />
        {isPVHasEV && <ChargerAlertDot />}
      </DropdownContainer>
    </Container>
  );
};

MultipleOpptys.propTypes = {
  changeServiceContract: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  selectedOption: PropTypes.string,
  isPVHasEV: PropTypes.bool,
};

MultipleOpptys.defaultProps = {
  selectedOption: null,
  isPVHasEV: false,
};

export default MultipleOpptys;
